import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, fleetPath } from '@/lib/api-client';
import { adaptServerList, type ApiServerList } from '@/lib/fleet-adapters';
import type { Paginated, ServerListItem, ServerListQuery } from '@/types/fleet';

import { fleetKeys } from './fleet-keys';

/** Re-fetch the server list every 30s while the page is visible. */
const POLL_INTERVAL_MS = 30_000;

export function useFleetServers(
  query: ServerListQuery,
): UseQueryResult<Paginated<ServerListItem>, Error> {
  return useQuery({
    queryKey: fleetKeys.servers(query),
    queryFn: async ({ signal }) =>
      adaptServerList(await apiClient.get<ApiServerList>(fleetPath('/servers', query), signal)),
    placeholderData: keepPreviousData,
    refetchInterval: (q) => (q.state.status === 'error' ? false : POLL_INTERVAL_MS),
    refetchIntervalInBackground: false,
  });
}
